module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedItem panel bg-lightest black"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "px-0 py-5 w-100"
  }, [_c('div', {
    staticClass: "w-100 pt-4"
  }, [_c('sales-daily', {
    attrs: {
      "height": 150,
      "chartData": _vm.stackBarsData
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 font-weight-600"
  }, [_c('span', {
    staticClass: "ml-1"
  }, [_vm._v("Daily Sales")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4135436c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/FeedcardSalesdaily.vue
// module id = 2177
// module chunks = 0